var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back_btn",on:{"click":_vm.backPage}},[_c('img',{attrs:{"src":"https://resources.sxsaas.com/static/jigou-saas-app/jiantou.png","alt":""}}),_c('div',{staticClass:"text"},[_vm._v("返回")])])
}
var staticRenderFns = []

export { render, staticRenderFns }